<template>
    <Modal :open="addGoodsStatus" @close="showAddGoodsModal()" align="center" animatedEnterClass="fadeInDown" animatedLeaveClass="fadeOutUp" class="ui-dialog">
        <div class="modal-content" style="width: 80vw;max-height:80vh;min-height:60vh">
            <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLabel">{{$Lang('以下商品缺失，请先新增')}}</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="showAddGoodsModal()">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body pT-15 pB-5">
                <form  @submit.prevent="validateBeforeSubmitAdd">
                    <div class="row">
                        <div class="table-responsive" style="max-height:60vh" ref="addGoodsBox">
                            <table class="table table-hover bgc-white table-bordered mB-0 ta-c" style="width:100%;">
                                <thead class="thead-light">
                                    <tr class="c-grey-900">
                                        <th width="120px">{{$Lang('条码')}}</th>
                                        <th width="170px">{{$Lang('名称')}}</th>
                                        <th width="120px">{{$Lang('分类')}}</th>
                                        <th width="120px">{{$Lang('品牌')}}</th>
                                        <th width="80px">{{$Lang('成本')}}</th>
                                        <th width="80px">{{$Lang('售价')}}</th>
                                        <th width="100px">{{$Lang('单位')}}</th>
                                        <th width="200px">{{$Lang('供应商')}}</th>
                                    </tr>
                                </thead>
                                <tbody class="fsz-xs ovY-a">
                                    <tr v-for="(val, key) in dataList" :key="key">
                                        <td>{{val.goods_barcode}}</td>
                                        <td>
                                            <input class="form-control" type="text" name="goods_name" v-model="val.goods_name" v-validate="'required'" :class="{'is-invalid': errors.has('goods_name') }" :data-vv-as="$Lang('名称')" />
                                            <span v-show="errors.has('goods_name')" class="invalid-feedback">{{ errors.first('goods_name') }}</span>
                                        </td>
                                        <td>
                                            <select class="form-control" :name="`goods_cat_id_`+key" v-model="val.goods_cat_id" v-validate="'required'" :class="{'is-invalid': errors.has(`goods_cat_id_`+key) }" :data-vv-as="$Lang('分类')">
                                                <option v-for="(v, k) in cateList" :value="v.goods_cat_id" :key="k">{{v.cat_name}}</option>
                                            </select>
                                            <span v-show="errors.has(`goods_cat_id_`+key)" class="invalid-feedback">{{ errors.first(`goods_cat_id_`+key) }}</span>
                                        </td>
                                        <td>
                                            <select class="form-control" name="goods_brand_id" v-model="val.goods_brand_id">
                                                <option v-for="(v, k) in brandList" :value="v.goods_brand_id" :key="k">{{v.brand_name}}</option>
                                            </select>
                                        </td>
                                        <td>
                                            <input class="form-control" type="text" :name="`cost_price_`+key" v-model="val.cost_price" v-validate="'required'" :class="{'is-invalid': errors.has(`cost_price_`+key) }" :data-vv-as="$Lang('成本')"/>
                                            <span v-show="errors.has(`cost_price_`+key)" class="invalid-feedback">{{ errors.first(`cost_price_`+key) }}</span>
                                        </td>
                                        <td>
                                            <input class="form-control" type="text" :name="`goods_price_`+key" v-model="val.goods_price" v-validate="'required'" :class="{'is-invalid': errors.has(`goods_price_`+key) }" :data-vv-as="$Lang('售价')"/>
                                            <span v-show="errors.has(`goods_price_`+key)" class="invalid-feedback">{{ errors.first(`goods_price_`+key) }}</span>
                                        </td>
                                        <td>
                                            <select class="form-control" name="goods_unit_id" v-model="val.goods_unit_id">
                                                <option v-for="(v, k) in unitList" :value="v.goods_unit_id" :key="k">{{v.unit_name}}</option>
                                            </select>
                                        </td>
                                        <td>
                                            <select class="form-control" name="goods_supplier_id" v-model="val.goods_supplier_id">
                                                <option v-for="(v, k) in supplierList" :value="v.goods_supplier_id" :key="k">{{v.supplier_name}}</option>
                                            </select>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    </form>
                </div>
                <div class="modal-footer ta-c">
                    <button type="button" class="btn btn-secondary" data-dismiss="modal" @click="showAddGoodsModal()">{{$Lang('取消')}}</button>
                    <button class="btn btn-success" type="button" @click="validateBeforeSubmitAdd()">{{$Lang('批量添加')}}</button>
                </div>
            </div>
    </Modal>
</template>
<script>
import goodsApi from '@/api/goods'
export default {
    name: 'batchAddGoods',
    props: {
        dataList: {
            type: Array,
            required: true
        },
        unitList: {
            type: Array
        },
        supplierList : {
            type: Array
        },
        shop_id : {
            type: String,
            required: true
        },
        onCancel: {
            type: Function
        },
        onConfirm: {
            type: Function
        }
    },
    mounted () {
        this.initData()
        this.addGoodsStatus = true
        this.$nextTick(() => {
            if (this.$refs.addGoodsBox) {
                this.addTheadScroll(this.$refs.addGoodsBox)
            }
        })
    },
    methods: {
        initData () {
            this.getBrandList()
            this.getCateList()
            this.getSupplierList()
            this.getUnitList()
        },
        addTheadScroll (obj) {
            obj.addEventListener('scroll', () => {
                let _top = obj.scrollTop
                obj.querySelector('thead').style.transform = _top > 0 ? 'translateY(' + _top + 'px)' : ''
            }, false)
        },
        showAddGoodsModal () {
            if (this.onCancel) {
                this.onCancel()
            }
            this.addGoodsStatus = false
        },
        validateBeforeSubmitAdd () {
            this.$validator.validateAll().then((result) => {
                if (result) {
                    this.list = []
                    let fields = [
                        'goods_barcode',
                        'goods_name',
                        'goods_cat_id',
                        'goods_brand_id',
                        'cost_price',
                        'goods_price',
                        'goods_unit_id',
                        'goods_supplier_id'
                    ];
                    this.dataList.forEach((v) => {
                        let _data = {'shop_id': this.shop_id}
                        for (let kk in v) {
                            fields.forEach((val) => {
                                if (kk === val) {
                                    _data[kk] = v[kk]
                                }
                            })
                        }
                        this.list.push(_data)
                    })
                    goodsApi.postBatchAdd({list: this.list}).then(response => {
                        if (response.data.status === 'succ') {
                            let _data = response.data.data
                            if (_data.fail) {
                                let _msg = _data.fail.join('<br />')
                                this.$Message.warning(_msg)
                            } else {
                                this.$Message.success(response.data.msg)
                            }
                        } else {
                            this.$Message.danger(response.data.msg)
                        }
                    }).catch(error => {
                        this.$Message.danger(error.toString())
                    })
                    if (this.onConfirm) {
                        this.onConfirm(this.list)
                    }
                    this.addGoodsStatus = false
                }
            })
        },
        // 读取分类的数据
        getUnitList () {
            if (this.unitList.length === 0) {
                goodsApi.getUnitList().then(response => {
                    if (response.data.status === 'succ') {
                        this.unitList = response.data.data
                    } else {
                        this.$Message.danger(response.data.msg)
                    }
                }).catch(error => {
                    this.$Message.danger(error.toString())
                })
            }
        },
        // 读取品牌
        getBrandList () {
            goodsApi.getBrandList().then(response => {
                if (response.data.status === 'succ') {
                    this.brandList = response.data.data
                } else {
                    this.$Message.danger(response.data.msg)
                }
            }).catch(error => {
                this.$Message.danger(error.toString())
            })
        },
        // 读取分类
        getCateList () {
            goodsApi.getCategoryList().then(response => {
                if (response.data.status === 'succ') {
                    this.cateList = response.data.data
                } else {
                    this.$Message.danger(response.data.msg)
                }
            }).catch(error => {
                this.$Message.danger(error.toString())
            })
        },
        // 读取供应商的数据
        getSupplierList () {
            if (this.supplierList.length === 0) {
                goodsApi.getSupplierList().then(response => {
                    if (response.data.status === 'succ') {
                        this.supplierList = response.data.data
                    } else {
                        this.$Message.danger(response.data.msg)
                    }
                }).catch(error => {
                    this.$Message.danger(error.toString())
                })
            }
        }
    },
    data () {
        return {
            list: [],
            addGoodsStatus: false,
            brandList: [],
            cateList: []
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/BatchAddGoods/batchAddGoods.vue